module.exports = __webpack_public_path__ + "static/media/nineteenth_robert_n_stewart_bridge2.71dc5129.jpg";